import { computed, makeObservable } from "mobx";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import { type WithRouterProps, withRouter } from "nvent-web/utils/withRouter";
import { compose } from "nvent-web/utils/compose";

import { ProjectsStore } from "nvent-web/stores/Projects";
import { RoomsStore } from "nvent-web/stores/Rooms";
import { type BuildingType } from "nvent-web/types/BuildingType";

import { getAncestryString } from "../../utils/getAncestryString";
import StepHeading from "../StepHeading/StepHeading";

import ProjectInsulationCard from "./components/ProjectInsulationCard/ProjectInsulationCard";
import { PROJECT_INSULATION_ITEMS } from "./projectInsulationItems";

interface EditProjectParams {
  projectId: string;
  roomId: string;
}

interface ProjectInsulationStepInnerProps
  extends EditProjectParams, WithRouterProps {
  projects: ProjectsStore;
  rooms: RoomsStore;
}

class ProjectInsulationStepInner extends Component<ProjectInsulationStepInnerProps> {
  constructor(props: ProjectInsulationStepInnerProps) {
    super(props);

    makeObservable(this, {
      projectId: computed,
      roomId: computed,
    });
  }

  get projectId(): number {
    return Number(this.props.params.projectId);
  }

  get roomId(): number {
    return Number(this.props.params.roomId);
  }

  componentDidMount() {
    this.props.projects.getProject(this.projectId);
  }

  render() {
    const { projectDetails } = this.props.projects;
    const { roomDetails } = this.props.rooms;

    const ancestryString = getAncestryString({
      projectName: projectDetails?.name,
      levels: roomDetails?.levels,
      roomName: roomDetails?.name,
    });
    return (
      <>
        <StepHeading step={1} ancestry={ancestryString} />
        {PROJECT_INSULATION_ITEMS.map(
          ({ buildingType, icon, title, description }) => (
            <ProjectInsulationCard
              buildingType={buildingType}
              key={buildingType}
              icon={icon}
              title={title}
              description={description}
              selected={Boolean(
                projectDetails && projectDetails.buildingType === buildingType
              )}
              onSelect={this.selectBuildingType}
            />
          )
        )}
      </>
    );
  }
  private selectBuildingType = async (buildingType: BuildingType) => {
    const { projectDetails, updateProject } = this.props.projects;
    if (projectDetails) {
      await updateProject(
        {
          project: {
            ...projectDetails,
            addressAttributes: projectDetails.address,
            buildingType,
          },
        },
        this.projectId
      );
      this.props.navigate(
        `/projects/${this.projectId}/rooms/${this.roomId}/selection-guide/room`
      );
    }
  };
}

const ProjectInsulationStep = compose(
  inject("projects", "rooms"),
  withRouter,
  observer
)(ProjectInsulationStepInner);

export default ProjectInsulationStep;
